export default __webpack_public_path__ + "static/media/ramp-left.79b9eacb.svg";